import React, { ChangeEvent, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useFormik } from "formik";
import LoadingButton from "@mui/lab/LoadingButton";
import CustomizedSnackbars from "../common/SnackBar";
import { v4 as uuidv4 } from "uuid";
import { upload } from "../../services/Upload";
import { Notify } from "../../layouts/notify";
import { useNavigate } from "react-router";
import { DefaultPage } from "../../layouts/default-page";
import { useAddChannelMutation } from "../../services/channel.query";
import { ChannelValidationsForm } from "./Validation";
import { PhotoCamera } from "@mui/icons-material";
import { title } from "process";

export default function AddTVProgramSchedule() {
  const navigate = useNavigate();
  const [addChannel, { isLoading }] = useAddChannelMutation();
  const [open, setOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [avatarImage, setAvatarImage] = useState<File | null>(null);

  const formik = useFormik({
    initialValues: {
      title: "",
      avatar_file: null,
    },
    validationSchema: ChannelValidationsForm,
    onSubmit: async (values, { resetForm }) => {
      let formData = {
        title: values.title,
        avatar_img: "",
      };

      try {
        if (values.avatar_file) {
          const file = avatarImage;
          const fileExt = file?.name.split(".").pop();
          const filePath = `${uuidv4()}-${Math.random()}.${fileExt}`;
          let data = await upload(file!, "images", filePath);
          formData.avatar_img = data.url;
        }

        console.log("formData: ", formData);
        await addChannel(formData);
        setOpen(true);
        setAvatarImage(null);
        setMessage("TV Channel created successfully.");
        Notify("info", "TV Channel created successfully.");
        navigate("/tv/channels");
        resetForm();
      } catch (error) {
        console.error("Error:", error);
        Notify("error", "Failed to create TV Channel.");
      }
    },
  });

  const handleAvatarImageChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.currentTarget.files) {
      setAvatarImage(e.target.files[0]);
      formik.setFieldValue("avatar_file", e.currentTarget.files[0]);
      formik.setErrors({ avatar_file: "" });
    }
  };

  return (
    <DefaultPage title="Add TV Program Schedule">
      <form onSubmit={formik.handleSubmit}>

        <div style={{ padding: 50 }}>
          <Grid container spacing={2}>
            {/* First row with one column */}
            <Grid item xs={6}>
              <Paper style={{ padding: 20, textAlign: 'center' }}>
                <Typography variant="h6">Single Column Row</Typography>
              </Paper>
            </Grid>

            {/* 7 rows with 2 columns each */}
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <Paper style={{ padding: 20, textAlign: 'center' }}>
                    <Typography>Column 1</Typography>
                  </Paper>
                </Grid>
                <Grid item xs={8}>
                  <Paper style={{ padding: 20, textAlign: 'center' }}>
                    <Typography>Column 2</Typography>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <Paper style={{ padding: 20, textAlign: 'center' }}>
                    <Typography>Column 1</Typography>
                  </Paper>
                </Grid>
                <Grid item xs={8}>
                  <Paper style={{ padding: 20, textAlign: 'center' }}>
                    <Typography>Column 2</Typography>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <Paper style={{ padding: 20, textAlign: 'center' }}>
                    <Typography>Column 1</Typography>
                  </Paper>
                </Grid>
                <Grid item xs={8}>
                  <Paper style={{ padding: 20, textAlign: 'center' }}>
                    <Typography>Column 2</Typography>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <Paper style={{ padding: 20, textAlign: 'center' }}>
                    <Typography>Column 1</Typography>
                  </Paper>
                </Grid>
                <Grid item xs={8}>
                  <Paper style={{ padding: 20, textAlign: 'center' }}>
                    <Typography>Column 2</Typography>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <Paper style={{ padding: 20, textAlign: 'center' }}>
                    <Typography>Column 1</Typography>
                  </Paper>
                </Grid>
                <Grid item xs={8}>
                  <Paper style={{ padding: 20, textAlign: 'center' }}>
                    <Typography>Column 2</Typography>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <Paper style={{ padding: 20, textAlign: 'center' }}>
                    <Typography>Column 1</Typography>
                  </Paper>
                </Grid>
                <Grid item xs={8}>
                  <Paper style={{ padding: 20, textAlign: 'center' }}>
                    <Typography>Column 2</Typography>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <Paper style={{ padding: 20, textAlign: 'center' }}>
                    <Typography>Column 1</Typography>
                  </Paper>
                </Grid>
                <Grid item xs={8}>
                  <Paper style={{ padding: 20, textAlign: 'center' }}>
                    <Typography>Column 2</Typography>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <Paper style={{ padding: 20, textAlign: 'center' }}>
                    <Typography>Column 1</Typography>
                  </Paper>
                </Grid>
                <Grid item xs={8}>
                  <Paper style={{ padding: 20, textAlign: 'center' }}>
                    <Typography>Column 2</Typography>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* Button at the bottom */}
          <div style={{ marginTop: 20, textAlign: 'center' }}>
            <Button variant="contained" color="primary">
              Click Me
            </Button>
          </div>
        </div>


      </form>
      <CustomizedSnackbars message={message} open={open} />
    </DefaultPage>
  );
}
